/* eslint-disable */
<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex d-flex xs12 lg8>
          <v-card>
            <v-toolbar
              color="blue darken-3"
              dark
            >
              <v-icon dark>calendar_today</v-icon>
              <v-toolbar-title>Calendar</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
                <full-calendar ref="calendar" :events="events" @event-created="eventCreated" :config="config"></full-calendar>

                <v-btn
                  fab
                  bottom
                  right
                  color="blue"
                  dark
                  absolute
                  height="30"
                  @click.stop="dialog = !dialog"
                  v-if="isAdmin"
                  style="bottom: -10px;"
                >
                  <v-icon>mdi-calendar-plus</v-icon>
                </v-btn>
            </v-card-text>
          </v-card>
      </v-flex>

      <v-flex d-flex xs12 lg4>
        <v-layout justify-center wrap>
          <v-flex xs12>
            <v-btn v-if="currentElection" block large round color="error" dark @click.stop="doVote">
              {{ voteText }}
              <v-icon right dark>ballot</v-icon>
            </v-btn>
            <v-btn v-if="conflict" block large round color="warning" dark @click.stop="doConflict">
              Conflict Form
            </v-btn>
            <v-btn block large round color="primary" dark @click.stop="suggestionEdit">
              Suggestion Box
              <v-icon right dark>help</v-icon>
            </v-btn>
            <v-card
              width="100%"
            >
              <v-toolbar
                color="blue darken-3"
                dark
              >
                <v-icon dark>message</v-icon>
                <!-- <v-toolbar-title>Message</v-toolbar-title> -->
                <v-toolbar-title>{{thePresident.firstName}}'s Message</v-toolbar-title>

                <v-btn fab absolute bottom right flat color="transparent">
                  <v-avatar
                    size="70px"
                    color="indigo"
                  >
                    <img v-if="thePresident.image" :src="thePresident.picture" alt="Avatar" />
                  </v-avatar>
                </v-btn>
              </v-toolbar>

              <v-card-text style="min-height: 100px;">
                <div v-html="messages[1].message" class="title pt-5 pb-5" style="line-height: 1.3 !important;"></div>

                <v-btn
                  fab
                  bottom
                  right
                  color="blue"
                  dark
                  absolute
                  height="30"
                  @click.stop="presMessageEdit(messages[1])"
                  v-if="isAdmin"
                  style="bottom: -10px;"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card
              width="100%"
            >
              <v-toolbar
                color="blue darken-3"
                dark
              >
                <v-icon dark>update</v-icon>
                <v-toolbar-title>Updates</v-toolbar-title>
              </v-toolbar>

              <v-card-text class="title" style="min-height: 100px;">
                <div v-html="messages[0].message" class="title pb-5" style="line-height: 1.3 !important;"></div>

                <v-btn
                  fab
                  bottom
                  right
                  color="blue"
                  dark
                  absolute
                  height="30"
                  @click.stop="messageEdit(messages[0])"
                  v-if="isAdmin"
                  style="bottom: -10px;"
                >
                  <v-icon>mdi-comment-plus</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-dialog persistent v-model="viewDialog" max-width="400px">
        <v-card>
          <v-toolbar color="indigo" dark>
            <span class="headline">{{selected.title}}</span>
            <v-btn
              color="blue"
              dark
              small
              absolute
              bottom
              right
              fab
              @click.stop="eventEdited(selected)"
              v-if="isAdmin"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <span class="body-2">{{formatedStartDate}}</span>
                </v-flex>
                <v-flex xs12>
                  <span class="body-2">{{selected.description}}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="closeView">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="pinDialog" max-width="400px">
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <span class="body-2">A Pin has been sent to your email to access voting. Please close this window and use the Pin to vote.</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="pinDialog = !pinDialog">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="voteDialog" max-width="400px">
        <v-card>
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="voteDialog = !voteDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ voteName }} Election</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="pin"
                    label="Enter Pin"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="enterPin">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="presDialog" max-width="400px">
        <v-card>
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="presDialog = !presDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit President's Message</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-textarea
                    v-model="presMessage.message"
                    auto-grow
                    box
                    label="Message"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="saveMessage">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="messageDialog" max-width="400px">
        <v-card>
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="messageDialog = !messageDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit Updates</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-textarea
                    v-model="presMessage.message"
                    auto-grow
                    box
                    label="Message"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="saveMessage">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="conflictDialog" max-width="800px">
        <v-card >
          <v-toolbar dark color="primary">
            <v-toolbar-title>Directors Obligation Acknowledgement</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout class="pb-3" row wrap>
                <v-flex xs12>
                  I have read and understand the Reno Rodeo Association's <b>Confidentiality Agreement and Conflict of Interest Policies</b>. I agree to abide by the
                  terms regarding confidentiality and conflicts of interest as outlined in these policies, acting in the best interest of the Reno Rodeo Association.
                </v-flex>
                <v-flex xs12>
                  A conflict of interest is defined as an interest that might affect, or might reasonably appear to affect, the judgment or conduct of any director
                  in an adverse manner to the interests of RRA.
                </v-flex>
                <v-flex xs12>
                  <a href="https://front.rrride.com/api/documents/Confidentiality_Agreement.pdf" target="_blank">Confidentiality Agreement and Conflict of Interest Policies</a>
                </v-flex>
                <v-flex xs12>
                  By signing below, I affirm that:
                  <ol>
                  <li>I have read and understand the Confidentiality Agreement and Conflict of Interest Policies;</li>
                  <li>I agree to comply with these policies.</li>
                  </ol>
                </v-flex>
                <v-flex xs12>
                  <b>To the best of my knowledge:</b>
                </v-flex>
                <v-radio-group v-model="member.conflict" :mandatory="false">
                <v-flex xs12>
                  <v-radio value="No"></v-radio>
                  <span class="body-1">I have no actual or potential conflicts to report</span>
                </v-flex>
                <v-flex xs12>
                  <v-radio value="Yes"></v-radio>
                  <span class="body-1">I have the following conflict of interest or potential conflict to report <i>(please specify other nonprofit and for-profit boards you
                    (or your spouse) sit on, any for-profit businesses for which you or an immediate family member are an officer or director, or a majority shareholder,
                    and the name of your employer and any businesses you or a family member own)</i></span>
                </v-flex>
                </v-radio-group>
                <v-flex xs4>
                  <v-text-field
                    v-model="member.cName1"
                    label="Name of Organization"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="member.cPosition1"
                    label="Position Held"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="member.cWhom1"
                    label="By Whom"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="member.cName2"
                    label="Name of Organization"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="member.cPosition2"
                    label="Position Held"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="member.cWhom2"
                    label="By Whom"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="member.cName3"
                    label="Name of Organization"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="member.cPosition3"
                    label="Position Held"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="member.cWhom3"
                    label="By Whom"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="member.cFullName"
                    label="Full Name"
                    hint="Please type your full name to electronically sign this document"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn color="primary" @click="setConflict">Accept</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="suggestionDialog" max-width="800px">
        <v-card>
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="suggestionDialog = !suggestionDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Suggestion Box</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  Please enter your question, comment or suggestion, someone from the manpower committee will be back with you soon.
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="suggestion.fullName"
                    label="Name (Optional)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="suggestion.email"
                    label="Email (Optional)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="suggestion.phone"
                    label="Phone (Optional)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="suggestion.message"
                    auto-grow
                    box
                    label="Message"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="saveSuggestion">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteDialog" max-width="400px">
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <span class="body-2">Are you sure you want to delete this event?</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-btn color="blue darken-1" flat @click="deleteItem()">Yes</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="deleteDialog = !deleteDialog">Cancel</v-btn>
          </v-card-actions>
        </v-card>

      </v-dialog>

      <v-dialog persistent v-model="dialog" max-width="600px">
        <v-card>
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn v-if="editedItem.id > 0" color="red" @click="deleteDialog = !deleteDialog">Delete</v-btn>
              <v-btn v-if="editedItem.id > 0" dark flat @click="updateItem()">Update</v-btn>
              <v-btn v-else dark flat @click="save">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.title"
                    label="Event Title"
                    style="font-size: 1.8em"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.location"
                    label="Event Location"
                    style="font-size: 1.8em"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="types"
                    v-model="type"
                    label="Event Type"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-checkbox label="All Day" v-model="editedItem.allDay"></v-checkbox>
                </v-flex>
                <v-flex class="hidden-xs-only" sm6 md8>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu1"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formatedStartDate"
                      label="Start Date"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="startDate"
                      no-title
                      @input="menu1 = false"
                      :max=this.endDate
                      @change="formatedStartDate = formatDate(startDate)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    :items="theTimes"
                    v-model="startTime"
                    label="Start Time"
                    prepend-icon="access_time"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formatedEndDate"
                      label="End Date"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="endDate"
                      no-title
                      @input="menu2 = false"
                      :min=this.startDate
                      @change="formatedEndDate = formatDate(endDate)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    :items="theTimes"
                    v-model="endTime"
                    label="End Time"
                    prepend-icon="access_time"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import Api from '@/services/Api'
import axios from 'axios'
import Utilities from '@/services/Utilities'
import { FullCalendar } from 'vue-full-calendar'
// import { RRule, RRuleSet } from 'rrule'
import { RRule } from 'rrule'
import 'fullcalendar/dist/fullcalendar.css'

import moment from 'moment'

export default {
  components: {
    FullCalendar
  },
  data () {
    return {
      currentPage: 'Dashboard',
      isAdmin: false,
      isPres: false,
      conflict: false,
      thePresident: {},
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
      types: ['Meeting', 'Foundation', 'Other'],
      type: '',
      theTimes: [
        '6:00 am',
        '6:15 am',
        '6:30 am',
        '6:45 am',
        '7:00 am',
        '7:15 am',
        '7:30 am',
        '7:45 am',
        '8:00 am',
        '8:15 am',
        '8:30 am',
        '8:45 am',
        '9:00 am',
        '9:15 am',
        '9:30 am',
        '9:45 am',
        '10:00 am',
        '10:15 am',
        '10:30 am',
        '10:45 am',
        '11:00 am',
        '11:15 am',
        '11:30 am',
        '11:45 am',
        '12:00 pm',
        '12:15 pm',
        '12:30 pm',
        '12:45 pm',
        '1:00 pm',
        '1:15 pm',
        '1:30 pm',
        '1:45 pm',
        '2:00 pm',
        '2:15 pm',
        '2:30 pm',
        '2:45 pm',
        '3:00 pm',
        '3:15 pm',
        '3:30 pm',
        '3:45 pm',
        '4:00 pm',
        '4:15 pm',
        '4:30 pm',
        '4:45 pm',
        '5:00 pm',
        '5:15 pm',
        '5:30 pm',
        '5:45 pm',
        '6:00 pm',
        '6:15 pm',
        '6:30 pm',
        '6:45 pm',
        '7:00 pm',
        '7:15 pm',
        '7:30 pm',
        '7:45 pm',
        '8:00 pm',
        '8:15 pm',
        '8:30 pm',
        '8:45 pm',
        '9:00 pm',
        '9:15 pm',
        '9:30 pm',
        '9:45 pm'
      ],
      formatedStartDate: '',
      formatedStartTime: '',
      formatedEndDate: '',
      formatedEndTime: '',
      dialog: false,
      viewDialog: false,
      suggestionDialog: false,
      editedIndex: -1,
      events: [],
      messages: [],
      config: {
        googleCalendarApiKey: 'AIzaSyDKmXIzjsMzI5PAgQMumGw6LdEWuxBhiRs',
        timeFormat: 'h:mm a',
        lazyFetching: true,
        eventClick: (event) => {
          this.eventSelected(event)
        },
        header: {
          left: window.innerWidth < 765 ? '' : 'title',
          center: window.innerWidth < 765 ? 'agendaDay,listMonth prev,today,next' : 'month,agendaWeek,agendaDay,listMonth',
          right: window.innerWidth < 765 ? '' : 'prev,today,next'
        },
        defaultView: window.innerWidth < 765 ? 'listWeek' : 'month',
        contentHeight: 0,
        businessHours: {
          dow: [ 1, 2, 3, 4, 5 ],

          start: '9:00',
          end: '17:00'
        }
      },
      holiday: {
        id: 0,
        title: '',
        start: '',
        end: '',
        allDay: true,
        description: '',
        userId: 0,
        color: ''
      },
      editedItem: {
        id: 0,
        title: '',
        start: '',
        end: '',
        allDay: false,
        description: '',
        location: '',
        userId: 0,
        color: ''
      },
      defaultItem: {
        id: 0,
        title: '',
        start: '',
        end: '',
        allDay: false,
        description: '',
        location: '',
        userId: 0,
        color: ''
      },
      selected: {},
      currentElection: false,
      currentElectionId: 0,
      currentVoter: false,
      voteText: '',
      pinDialog: false,
      voteDialog: false,
      presDialog: false,
      messageDialog: false,
      conflictDialog: false,
      presMessage: {},
      suggestion: {},
      member: {},
      voteName: '',
      pin: '',
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      deleteDialog: false
    }
  },

  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    this.$store.dispatch('setCurrentPage', this.currentPage)

    if (this.$store.state.isAdmin) {
      this.isAdmin = true
    } else {
      this.isAdmin = this.$store.state.controls.includes('Calendar')
    }

    if (this.$store.state.isAdmin) {
      this.isPres = true
    } else {
      this.isPres = this.amPresident()
    }

    this.getUser()
    this.getEvents()
    this.getHolidays()
    this.getPresident()
    this.getMessages()
    this.getElection()
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Event' : 'Edit Event'
    },

    applyStartTime () {
      if (this.startDate === this.endDate) {
        return this.startTime
      }
    }
  },

  methods: {
    async getEvents () {
      try {
        let response = await Api().get('get_events')

        const events = response.data
        console.log('events', events)

        for (let i = 0; i < events.length; i++) {
          events[i].realTitle = events[i].title
          if (events[i].location) {
            events[i].title = events[i].title + '\n(' + events[i].location + ')'
          }

          if (events[i].committeeCode) {
            events[i].title = events[i].committeeCode + ' - ' + events[i].title
          }

          if (events[i].rrule) {
            let startcalc = events[i].start.split('T')
            let endcalc = events[i].end.split('T')
            let startdate = moment(startcalc[0])
            let enddate = moment(endcalc[0])
            console.log('end', enddate)

            let days = enddate.diff(startdate, 'days')

            let rrule = events[i].rrule
            rrule = rrule.replace('~', '\n')

            // let rule = RRule.fromString(rrule)
            // let rule = RRule.fromText('every month on the 1st Monday until 07/04/2019')
            let rule = RRule.fromText('every 2 weeks on TU until 07/04/2019')

            let rulea = rule.all()

            for (let j = 0; j < rulea.length; j++) {
              let newEvent = {}
              let start = moment(rulea[j]).format('YYYY-MM-DD') + 'T' + startcalc[1]
              let end = moment(rulea[j]).add(days, 'days').format('YYYY-MM-DD') + 'T' + endcalc[1]

              newEvent.id = events[i].id
              newEvent.title = events[i].title + '(Reoccuring)'
              newEvent.start = start
              newEvent.end = end
              newEvent.allDay = events[i].allDay
              newEvent.description = events[i].description
              newEvent.userId = events[i].userId
              newEvent.color = events[i].color
              newEvent.rrule = events[i].rrule

              this.events.push(newEvent)
            }
          } else {
            this.events.push(events[i])
          }
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getHolidays () {
      try {
        await axios.get('https://www.googleapis.com/calendar/v3/calendars/en.usa%23holiday%40group.v.calendar.google.com/events?key=AIzaSyDKmXIzjsMzI5PAgQMumGw6LdEWuxBhiRs')
          .then(res => {
            const holidays = res.data.items

            for (let i = 0; i < holidays.length; i++) {
              const holiday = {}

              holiday.title = holidays[i].summary
              holiday.start = holidays[i].start.date
              holiday.end = holidays[i].end.date
              holiday.allDay = 1
              holiday.description = holidays[i].summary
              holiday.userId = 0
              holiday.color = 'gray'

              this.events.push(holiday)
            }
          })
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getUser () {
      try {
        let response = await Api().get('users/' + this.$store.state.user.id)
        // console.log(response.data)
        var user = response.data

        console.log('Test', user)

        if (user.TitleId === 1 || user.TitleId === 3) {
          if (user.conflict === '' || user.conflict === null) {
            this.conflict = true
          }
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async amPresident () {
      try {
        let response = await Api().get('exec_groups/president/' + this.$store.state.currentYear + '/' + this.$store.state.user.id)
        // console.log(response.data)
        return response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    presMessageEdit (item) {
      this.presDialog = true
      this.presMessage = item
    },

    messageEdit (item) {
      this.messageDialog = true
      this.presMessage = item
    },

    suggestionEdit () {
      this.suggestionDialog = true
    },

    async saveSuggestion () {
      try {
        this.suggestion.date = moment().format('YYYY-MM-DD')
        let response = await Api().post('suggestion/', this.suggestion)

        this.suggestionDialog = false
        this.presDialog = false
        this.messageDialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async saveMessage () {
      try {
        let response = await Api().put('update_message/' + this.presMessage.id, this.presMessage)

        this.presDialog = false
        this.messageDialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getElection () {
      const hour = moment().format('H')
      const date = moment().format('YYYY-MM-DD')
      // console.log(hour, date)

      try {
        if (this.$store.state.user.TitleId === 1 || this.$store.state.user.TitleId === 3) {
          let response = await Api().get('currentelections')
          // console.log(response.data)
          this.voteName = response.data.name
          let voters = response.data.ElectionVoters
          let startDate = response.data.startDate
          let endDate = response.data.endDate
          // console.log(hour, date, startDate)

          if (
            ((date === startDate && hour >= 8) ||
            (date > startDate)) &&
            ((date === endDate && hour <= 16) ||
            (date < endDate))
          ) {
            if (voters.length > 0) {
              const myVote = voters.find(x => x.UserId === this.$store.state.user.id)

              if (typeof myVote !== 'undefined') {
                if (myVote.voteDate) {
                  this.currentElection = false
                } else if (myVote.pin) {
                  this.currentVoter = true
                  this.currentElection = true
                  this.voteText = 'Vote (' + this.voteName + ')'
                  this.currentElectionId = response.data.id
                } else {
                  this.currentVoter = false
                  this.voteText = 'Get Vote Code'
                  this.currentElection = true
                  this.currentElectionId = response.data.id
                }
              } else {
                this.currentVoter = false
                this.voteText = 'Get Vote Code'
                this.currentElection = true
                this.currentElectionId = response.data.id
              }
            } else {
              this.currentVoter = false
              this.voteText = 'Get Vote Code'
              this.currentElection = true
              this.currentElectionId = response.data.id
            }
          }

          return response.data
        } else {
          this.currentElection = false
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    doConflict () {
      this.conflictDialog = true
    },

    async setConflict () {
      try {
        // this.member.name = this.name
        this.member.userId = this.$store.state.user.id
        this.member.cDate = moment().format('YYYY-MM-DD HH:MM:ss')

        const response = await Api().post('set_conflict', this.member)

        // console.log('res', response)
        this.conflictDialog = false
        this.conflict = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async doVote () {
      try {
        if (this.currentVoter) {
          this.voteDialog = true
        } else {
          let response = await Api().post('add_voter/' + this.$store.state.user.email + '/' + this.$store.state.user.id + '/' + this.currentElectionId)
          this.pinDialog = true
          this.currentVoter = true
          this.voteText = 'Vote (' + this.voteName + ')'
          return response.data
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async enterPin () {
      try {
        let response = await Api().get('enter_pin/' + this.pin + '/' + this.$store.state.user.id + '/' + this.currentElectionId)

        if (response.data === 'Bad Pin') {
          this.snackbar.message = 'Invalid Pin'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        } else {
          this.$router.push('vote')
        }

        // console.log(response)
      } catch (error) {
        this.error = error.repsonse.data.error
      }
    },

    async getPresident () {
      try {
        let response = await Api().get('exec_groups/get_president/' + this.$store.state.currentYear)

        this.thePresident = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getMessages () {
      try {
        const today = new Date().toISOString().slice(0, 10)

        const response = await Api().get('get_messages')

        const messages = response.data

        for (let i in messages) {
          // console.log(messages[i].date)
          if (messages[i].date >= today) {
            let messageItem = {
              id: messages[i].id,
              message: messages[i].message,
              date: messages[i].date
            }
            this.messages.push(messageItem)
            // console.log(messageItem)
          }
        }

        this.messages = response.data
        // console.log(this.messages)
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 330
      this.config.contentHeight = height
    },

    refreshEvents () {
      this.$refs.calendar.$emit('refetch-events')
    },

    removeEvent () {
      this.$refs.calendar.$emit('remove-event', this.selected)
      this.selected = {}
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    makeStartTime (time) {
      this.$refs.menu.save(this.startTime)

      return Utilities.displayTime(time)
    },

    makeEndTime (time) {
      this.$refs.menua.save(this.endTime)

      return Utilities.displayTime(time)
    },

    eventSelected (event) {
      this.selected = event

      if (this.selected.allDay) {
        this.formatedStartDate = moment(this.selected.start).format('ddd, MMM Do') + ' - All Day'
      } else {
        this.formatedStartDate = moment(this.selected.start).format('ddd, MMM Do h:mm A - ') +
          moment(this.selected.end).format('ddd, MMM Do h:mm A')
      }

      this.viewDialog = true
      // console.log('edit', this.selected)
    },

    eventCreated (...test) {
      // console.log('new', test)
      const event = test[0]

      this.editedItem.allDay = true
      this.startDate = moment(event.start).format('YYYY-MM-DD')
      this.endDate = moment(event.end).format('YYYY-MM-DD')
      this.formatedStartDate = moment(event.start).format('MM/DD/YYYY')
      this.formatedEndDate = moment(event.end).format('MM/DD/YYYY')

      this.dialog = true
    },

    eventEdited (props) {
      console.log('props', props)
      this.editedItem.id = props.id
      this.editedItem.title = props.realTitle
      this.editedItem.allDay = props.allDay
      this.editedItem.description = props.description
      this.editedItem.location = props.location
      this.editedItem.userId = props.userId
      this.editedItem.color = props.color
      this.editedItem.UserId = props.UserId
      this.editedItem.start = moment(props.start).format()

      if (props.allDay === true) {
        this.editedItem.end = moment(props.start).format()
      } else {
        this.editedItem.end = moment(props.end).format()
      }
      // console.log(this.editedItem)

      // this.editedItem.index = props.id
      this.startDate = moment(props.start).format('YYYY-MM-DD')
      this.endDate = moment(this.editedItem.end).format('YYYY-MM-DD')
      this.formatedStartDate = moment(props.start).format('MM/DD/YYYY')
      this.formatedEndDate = moment(this.editedItem.end).format('MM/DD/YYYY')

      this.startTime = moment(props.start).format('h:mm a')
      this.endTime = moment(this.editedItem.end).format('h:mm a')

      this.viewDialog = false
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.deleteDialog = false
      this.conflictDialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.startTime = ''
        this.startDate = ''
        this.endDate = ''
        this.endTime = ''
        this.formatedStartDate = ''
        this.formatedStartTime = ''
        this.formatedEndDate = ''
        this.formatedEndTime = ''
      }, 300)
    },

    closeView () {
      this.viewDialog = false
      setTimeout(() => {
        this.selected = {}
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.startTime = ''
        this.startDate = ''
        this.endDate = ''
        this.endTime = ''
        this.formatedStartDate = ''
        this.formatedStartTime = ''
        this.formatedEndDate = ''
        this.formatedEndTime = ''
      }, 300)
    },

    updateItem () {
      let index = this.events.findIndex(x => x.id === this.editedItem.id)
      let obj = this.events.find(x => x.id === this.editedItem.id)

      obj.location = this.editedItem.location
      obj.title = this.editedItem.title
      obj.startTime = this.editedItem.startTime
      obj.endTime = this.editedItem.endTime

      this.updateEvent(this.editedItem)

      obj.realTitle = obj.title
      obj.title = obj.title + '\n(' + obj.location + ')'

      this.events[index] = obj
      console.log('index', index)
      console.log('obj', obj)
    },

    async   deleteItem () {
      try {
        const response = await Api().delete('events/' + this.editedItem.id)

        const index = this.events.findIndex(item => item.id === this.editedItem.id)

        this.events.splice(index, 1)

        this.close()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateEvent (event) {
      try {
        const response = await Api().put('events/' + event.id, event)

        this.close()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    save () {
      // const rule = new RRule({
      //   freq: RRule.WEEKLY,
      //   interval: 5,
      //   byweekday: [RRule.MO, RRule.FR],
      //   dtstart: new Date(Date.UTC(2012, 1, 1, 10, 30)),
      //   until: new Date(Date.UTC(2012, 12, 31))
      // })

      // console.log(rule.toString())

      let startTime = 'T' + moment(this.startTime, ['h:mm A']).format('HH:mm:00')
      let endTime = 'T' + moment(this.endTime, ['h:mm A']).format('HH:mm:00')

      if (!this.startTime) { this.editedItem.allDay = true }

      if (this.editedItem.allDay) {
        startTime = ''
        endTime = ''
      }

      if (!this.endDate) {
        this.endDate = this.startDate
      }

      this.editedItem.start = this.startDate + startTime

      if (!this.endTime && !this.editedItem.allDay) {
        this.editedItem.end = moment(this.editedItem.start).add(1, 'hour').format('YYYY-MM-DDTHH:mm:00')
      } else {
        this.editedItem.end = this.endDate + endTime
      }

      this.editedItem.UserId = this.$store.state.user.id

      if (this.type === 'Foundation') {
        this.editedItem.color = '#4e9c3d'
      } else if (this.type === 'Other') {
        this.editedItem.color = '#a9602d'
      } else {
        this.editedItem.color = '#3a87ad'
      }

      this.type = ''

      console.log(this.editedItem)
      if (this.editedIndex > -1) {
        // console.log('edit')
        // Object.assign(this.rows[this.editedIndex], this.editedItem)
      } else {
        this.saveEvent(this.editedItem)
        this.events.push(this.editedItem)
      }
      // console.log('editedItem', this.editedItem)
      // console.log(this.events)
      // this.close()
    },

    async saveEvent (event) {
      try {
        const response = await Api().post('events', event)

        this.close()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
  // computed: {
  //   eventSources () {
  //     const self = this
  //     return [
  //       {
  //         events (start, end, timezone, callback) {
  //           setTimeout(() => {
  //             callback(self.events.filter(() => Math.random() > 0.5))
  //           }, 1000)
  //         }
  //       }
  //     ]
  //   }
  // }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue